import * as React from 'react'
import { Link, Redirect } from 'react-router-dom'
import UIMessages from '../../../utils/ui-messages'
import { handleRedirect } from 'src/utils'
import { Button } from '@mobiscroll/react-latest'

interface IProps {
  isSaved: boolean
  isSaving?: boolean
  finishPath?: string
  nextStepPath?: string
  previousStepPath?: string
  skipStepPath?: string
  isEdit?: boolean
  disableContinueBtn?: boolean
  disableFinishBtn?: boolean
  onSave?: () => void
}
const redirectToConnect = (finishPath: string) => {
  if (typeof finishPath === 'string' && finishPath.includes('https')) {
    window.location.href = finishPath
  } else {
    const path = finishPath.replace('/null', '')
    handleRedirect(path)
  }
}
const CreateOrganizationBottomBar = ({
  disableContinueBtn = false,
  disableFinishBtn = false,
  isSaved,
  isSaving,
  finishPath,
  nextStepPath,
  previousStepPath,
  skipStepPath,
  onSave,
  isEdit
}: IProps) => {
  const saveText = isSaving ? UIMessages.common.saving : UIMessages.common.save
  return (
    <div className='flex absolute bottom-0 flex items-center justify-end bg-light-grey7 px2 py1 w100 z1'>
      <div className='flex justify-end pr3 w100'>
        {previousStepPath && (
          <Button
            ariaLabel='Previous step button'
            className='mbsc-outline-success-btn'
            onClick={() => handleRedirect(previousStepPath)}
          >
            {UIMessages.common.previousStep}
          </Button>
        )}
        {!finishPath && isSaved && skipStepPath && (
          <Button
            ariaLabel='Skip step button'
            className='mbsc-flat-white-btn'
            onClick={() => handleRedirect(skipStepPath)}
          >
            {UIMessages.common.skip}
          </Button>
        )}
        {!isSaved && onSave && (
          <Button ariaLabel='Save button' className='mbsc-success-btn' onClick={onSave}>
            {saveText}
          </Button>
        )}
        {!isSaved && !onSave && (
          <Button ariaLabel='Submit button' className='mbsc-success-btn' type='submit'>
            {saveText}
          </Button>
        )}
        {((isEdit && nextStepPath) || (!finishPath && isSaved && nextStepPath)) && (
          <Button
            ariaLabel='Continue button'
            className='mbsc-success-btn'
            disabled={disableContinueBtn}
            onClick={() => handleRedirect(nextStepPath)}
          >
            {UIMessages.common.continueLabel}
          </Button>
        )}
        {finishPath && isSaved && (
          <Button
            ariaLabel='Finish button'
            className='mbsc-success-btn'
            disabled={disableFinishBtn}
            onClick={() => redirectToConnect(finishPath)}
          >
            {UIMessages.common.finish}
          </Button>
        )}
      </div>
    </div>
  )
}

export default CreateOrganizationBottomBar



// WEBPACK FOOTER //
// ./src/components/organizations/create/CreateOrganizationBottomBar.tsx